// extracted by mini-css-extract-plugin
export default {"toggleLabel":"UserPermissions_toggleLabel__Xc-mQ","adminToggle":"UserPermissions_adminToggle__h7Ta0"};